import React, { useState } from "react";
import {
  Container,
  Divider,
  IconButton,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Typography,
} from "@mui/material";
import {
  HomeOutlined,
  DesktopWindowsOutlined,
  PowerSettingsNewOutlined,
} from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { signOut } from "../../Store/Actions/signOut";
import { useNavigate } from "react-router-dom";
import styles from "./AdminSidePanel.module.css";
import { Link, useLocation } from "react-router-dom";

const AdminSidePanel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selected, setSelected] = useState(0);

  const onLogout = () => {
    dispatch(signOut());
    navigate("/pos", { replace: true });
  };

  const location = useLocation();

  const list = [
    {
      name: "User Management",
      link: "/admin/user",
    },
    {
      name: "Roles Management",
      link: "/admin/role",
    },
    {
      name: "Privilege Management",
      link: "/admin/privilege",
    },
    {
      name: "Br Privilege Mapping",
      link: "/admin/br-priv-mapping",
    },
    // {
    //   name: "Category Management",
    //   link: "/admin/category",
    // },

  ];

  return (
    <div className={styles.container} elevation={3}>

      <Typography className={styles.title}>ADMIN DASHBOARD</Typography>
      <div>
        <MenuList className={styles.listContainer}>
          {list.map((item) => (
            <Link key={item.link} className={styles.link} to={item.link}>
              <MenuItem
                className={
                  location.pathname === item.link
                    ? styles.selected
                    : styles.listItem
                }
              >
                <ListItemText>{item.name}</ListItemText>
              </MenuItem>
            </Link>
          ))}
        </MenuList>
      </div>
    </div>
  );
};

export default AdminSidePanel;
